import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthAside from '../components/AuthAside';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(form.username, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Kullanıcı adı veya şifre hatalı.');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-shell">
      <AuthAside />

      <div className="auth-main">
        <div className="auth-card">
          <div className="auth-brand-mobile">muhasib<span>.</span></div>

          <h1>Giriş yapın</h1>
          <div className="auth-sub">Firmanızın defterine kaldığınız yerden devam edin.</div>

          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label className="field-label" htmlFor="username">Kullanıcı adı</label>
              <input
                id="username"
                value={form.username}
                onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
                placeholder="kullanıcı adınız"
                autoComplete="username"
                autoFocus
              />
            </div>

            <div className="auth-field" style={{ marginBottom: 20 }}>
              <label className="field-label" htmlFor="password">Şifre</label>
              <input
                id="password"
                type="password"
                value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="alert alert-error" style={{ marginBottom: 14 }} role="alert">{error}</div>
            )}

            <button type="submit" disabled={loading} className="btn btn-green auth-submit">
              {loading ? 'Giriş yapılıyor…' : 'Giriş yap'}
            </button>
          </form>

          <div className="auth-foot">
            Hesabınız yok mu? <Link to="/register">Kayıt olun</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
